import { render, staticRenderFns } from "./DsfrFullName.vue?vue&type=template&id=40ffc884&"
import script from "./DsfrFullName.vue?vue&type=script&lang=js&"
export * from "./DsfrFullName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports